var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('b-form-group',{staticClass:"col-sm-12 p-0",attrs:{"id":"group-record.locale.notes","label":_vm.$t('form.notes'),"label-for":"record.locale.notes","description":"","label-class":"mb-0"}},[_c('vue-editor',{model:{value:(_vm.record.notes),callback:function ($$v) {_vm.$set(_vm.record, "notes", $$v)},expression:"record.notes"}})],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }